import React from "react";
import { Modal } from "react-bootstrap";
import { FiExternalLink } from "react-icons/fi";
import "./Notifications.css";

const NotificationImageModal = ({ show, close, data }) => {
  return (
    <Modal show={show} onHide={close} dialogClassName="notif-image-modal" centered>
      <Modal.Header closeButton>
        <Modal.Title>Notification Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-center">
          <img className="notif-image-modal-img" src={process.env.REACT_APP_URL_S3 + "/" + data?.image} alt="Notification" />
        </div>
      </Modal.Body>
      {data?.link && (
        <Modal.Footer className="border-0 d-flex justify-content-center">
          <a href={data?.link} target="_blank" rel="noopener noreferrer" className="notif-image-modal-link-btn" onClick={close}>
            View Details <FiExternalLink size={14} />
          </a>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default NotificationImageModal;
